import WebComponent from "./_web_component";

export default class WCCalcLiq extends WebComponent {
	constructor(el, params) {
		super(el, params)
	}

	init(){
		const {
			url,
			elValCalc,
			elValInput
		} = this.params

		$(this.element).on("change", (e) => {
			const userId = $(e.target).val()

			if (userId) {
				const alert = Alertify.log.create("info", "Calculando...")
				$.ajax({
					type: 'GET',
					url: `${url}/${userId}`,
					success: data => {
						const valLiq = data && data.dineroCaja
						$(elValCalc).val(valLiq)
						$(elValCalc).data('vrliq', valLiq)
						$(elValInput).val('')
						alert.close()
						Alertify.log.success('Calculo Hecho')
					}
				})
			} else {
				$(elValCalc).val(0)
			}
		});
	}
}
